<button mat-raised-button aria-label="Exportar tabla a PDF" class="{{cssClass}} fa fa-lg fa-file-pdf-o"
  matTooltip="Exportar tabla a PDF"></button>
